// ----------------------------------------------------------------------

export default function Table(theme) {
    return {
        MuiCard: {
            styleOverrides: {
                root: {
                    "&:hover": {
                        boxShadow: "none",
                        cursor: "default",
                    },
                },
            },
        },
    };
}
